import {Injectable} from '@angular/core';
import {UndoService} from '../../commands/undo.service';
import {RequestsService} from '../../core/requests/requests.service';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {DiagramUpdateService} from '../../diagram-data/diagram-update.service';
import * as _ from 'lodash';
import {MapTreeService} from '../../core/services/map-tree.service';

@Injectable()
export class RenumberService {
  constructor(
    private undoSvc: UndoService,
    private requestsSvc: RequestsService,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private graphHelper: GraphHelperService,
    private registrySvc: EditorRegistryService,
    private mapTreeSvc: MapTreeService,
    private diagramUpdateSvc: DiagramUpdateService
  ) {}

  renumberActivity(activityMxKey, number) {
    return this._changeNumber({activityMxKey: activityMxKey, number: number}).then(() => {
      this.undoSvc.clear();
    });
  }

  private _changeNumber(data) {
    const action = {
      changeActivity: {
        mxKey: data.activityMxKey,
        number: data.number
      }
    };

    const activityCache = _.find(this.graphHelper.allActivities(), cell => {
      return parseInt(cell.id, 10) === parseInt(data.activityMxKey, 10);
    });

    return this.diagramUpdateSvc.update(action, true).then(() => {
      const drilldowns = activityCache.comp.instance.source.drilldowns;

      if (drilldowns && drilldowns.length) {
        this.mapTreeSvc.triggerUpdate();
      }

      return activityCache.comp.instance.setupFromJson();
    });
  }

  swapActivity(list) {
    return this._swapNumber(list).then(() => {
      this.mapTreeSvc.triggerUpdate();
    });
  }

  private _swapNumber(list) {
    const action = {
      groupRenumber: {
        list: list
      }
    };

    this.undoSvc.clear();
    const promises = [];

    return this.diagramUpdateSvc.update(action, true, true).then(() => {
      this.diagramJsonSvc.update(action);
      list.forEach(item => {
        promises.push(this._changeNumberSmart(item.mxKey));
      });
    });
  }

  doSmartRenumber() {
    const ttb = this.graphHelper.allActivities().sort(this._verticalSort);
    const len = ttb.length;
    const renumberList = [];

    if (len < 2 || !this.registrySvc.getEditorUI().editor.graph.enabled) {
      return Promise.reject(1);
    }

    for (let i = 0; i < len; i++) {
      for (let j = i + 1; j < len; j++) {
        if (this._isInRange(ttb[i], ttb[j], 80)) {
          if (ttb[i].geometry.x > ttb[j].geometry.x) {
            const temp = ttb[i];

            ttb[i] = ttb[j];
            ttb[j] = temp;
          }
        }
      }

      renumberList.push({
        mxKey: ttb[i].id,
        number: i + 1
      });
    }

    return this._groupRenumber(renumberList).then(() => {
      this.mapTreeSvc.triggerUpdate();

      return renumberList.length;
    });
  }

  private _verticalSort(a, b) {
    if (a.geometry.y > b.geometry.y) {
      return 1;
    }

    if (a.geometry.y < b.geometry.y) {
      return -1;
    }

    return 0;
  }

  private _isInRange(cell1, cell2, cof) {
    const range = [cell1.geometry.y - cof, cell1.geometry.y + cof];
    const pt = cell2.geometry.y;

    return pt >= range[0] && pt <= range[1];
  }

  private _groupRenumber(list) {
    const promises = [];
    const action = {
      groupRenumber: {
        list: list
      }
    };

    this.undoSvc.clear();

    return this.diagramUpdateSvc.update(action, true, true).then(() => {
      this.diagramJsonSvc.update(action);
      list.forEach(item => {
        promises.push(this._changeNumberSmart(item.mxKey));
      });
    });
  }

  private _changeNumberSmart(activityMxKey) {
    const activityCache = _.find(this.graphHelper.allActivities(), cell => {
      return parseInt(cell.id, 10) === parseInt(activityMxKey, 10);
    });

    activityCache.comp.instance.setupFromJson();
  }
}
